import HideCard from './HideCard';

export default HideCard;
